import React from "react";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

const ContactFeatures = () => {
  return (
    <>
      {/* Header Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container text-center">
     
          <h2 className="page-header__title" style={{ color: "#ffffff" }}>
            Contact Us
          </h2>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-5" style={{ backgroundColor: "#f7fbff" }}>
        <div className="container">
          <div className="row gy-4 justify-content-center">

            {/* Phone */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-box text-center p-4 shadow-sm"
                style={{
                  background: "#003b66",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <FiPhone size={40} color="#47a9dd" />
                <p className="mt-3">Have A Question?</p>
                <h3>
                  <a href="tel:+918010014995" style={{ color: "#47a9dd" }}>
                    +91 8010014995
                  </a>
                </h3>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-box text-center p-4 shadow-sm"
                style={{
                  background: "#003b66",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <FiMail size={40} color="#47a9dd" />
                <p className="mt-3">Email Us On</p>
                <h3 style={{fontSize:'20px'}}>
                  <a href="mailto:booking@amrutatravelspvtltd.com" style={{ color: "#47a9dd" }}>
                    booking@amrutatravelspvtltd.com
                  </a>
                </h3>
              </div>
            </div>

            {/* Location */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-box text-center p-4 shadow-sm"
                style={{
                  background: "#003b66",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <FiMapPin size={40} color="#47a9dd" />
                <p className="mt-3">Amruta Travels Pvt Ltd</p>
                <p className="mt-3">OUR OFFICE LOCATION</p>
                <h3 style={{fontSize:'20px'}}>Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041</h3>
              </div>
            </div>

          </div>

      
        </div>
      </section>
    </>
  );
};

export default ContactFeatures;
